import {BaseTileProvider} from './base-tile-provider';
import {MapType} from '../../enums/map-type';
import {MapProvider} from '../../enums/map-provider.enum';
import {SettingsService} from '../../services/settings.service';

export class UsgsTileProvider extends BaseTileProvider {

  // SATELLITE is the bare photograph (detection always asks for it, so it must
  // carry no drawn roads or names); HYBRID is the same imagery with the topo
  // contours, roads and place names drawn in.
  private static URL_USGS_SAT = 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryOnly/MapServer/tile/{z}/{y}/{x}';
  private static URL_USGS_HYBRID = 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryTopo/MapServer/tile/{z}/{y}/{x}';
  private static URL_USGS_MAP = 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSTopo/MapServer/tile/{z}/{y}/{x}';

  getMapProvider(): string {
    return MapProvider.USGS;
  }

  getMaxZoom(): number {
    return 20;
  }

  getUrlTemplate(mapType?: MapType): string {
    let mt = mapType;
    if(!mt){
      mt = SettingsService.settings.mapType;
    }
    let url = '';
    switch (mt) {
      case MapType.MAP:
      case MapType.TERRAIN:
        url = UsgsTileProvider.URL_USGS_MAP;
        break;
      case MapType.SATELLITE:
        url = UsgsTileProvider.URL_USGS_SAT;
        break;
      case MapType.HYBRID:
        url = UsgsTileProvider.URL_USGS_HYBRID;
        break;
    }
    return url;
  }

  getUrl(x, y, zoom, mapType?: MapType): string {
    // The template already carries the row/column order, so there is
    // nothing to decide here -- the switch this used to run built a
    // second URL that was then discarded.
    return this.getUrlTemplate(mapType)
      .replace('{z}', zoom)
      .replace('{x}', x)
      .replace('{y}', y);
  }

}
